/* global axios */

import ApiClient from './ApiClient';

class KnowledgeSearchAPI extends ApiClient {
  constructor() {
    super('kb/search', { accountScoped: true });
  }

  search(query) {
    return axios.get(this.url, { params: { q: query } });
  }
}

export default new KnowledgeSearchAPI();
